module.exports = __webpack_public_path__ + "img/8手机.29e2eb10.png";